import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "../commons/abstract.service";
import { Product } from "../models/product.model";

@Injectable({ providedIn: 'root' })
export class ProductService extends AbstractService<Product> {
  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/product';
  }

  preCreate(obj: Product): void {
    delete obj._id;
  }

  preUpdate(obj: Product): void {
  }
}
